var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.25,152.55l0-.13c-5.38-18.57-21.62-30.63-37.65-39.83-32.35-18.57-62.35-6.76-109,5s-75-.32-117.34-13.35C102,84.79,54.35,144.79,63,204.37c4.09,28.07,16.75,53.93,21.88,81.77,7.51,40.81-22.07,59.66,1.39,94.08S173,422.5,215.21,415.85c25.57-4,47.71-18.31,71.88-26.65,22.67-7.82,47.31-6.12,70,.69,21.05,6.31,46,12.52,63.84-4.52C441.22,366,448,343.08,438.05,316.78c-8.62-22.77-24.8-42.13-32.15-65.41-6.2-19.59,5.6-30.51,14.72-46.36C429.44,189.68,434.23,169.91,429.25,152.55Z",
    style: {
      fill: "#F77474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.25,152.55l0-.13c-5.38-18.57-21.62-30.63-37.65-39.83-32.35-18.57-62.35-6.76-109,5s-75-.32-117.34-13.35C102,84.79,54.35,144.79,63,204.37c4.09,28.07,16.75,53.93,21.88,81.77,7.51,40.81-22.07,59.66,1.39,94.08S173,422.5,215.21,415.85c25.57-4,47.71-18.31,71.88-26.65,22.67-7.82,47.31-6.12,70,.69,21.05,6.31,46,12.52,63.84-4.52C441.22,366,448,343.08,438.05,316.78c-8.62-22.77-24.8-42.13-32.15-65.41-6.2-19.59,5.6-30.51,14.72-46.36C429.44,189.68,434.23,169.91,429.25,152.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-61"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "266.74 286.7 238.74 286.7 238.74 249.19 258.4 249.19 266.74 256.83 266.74 286.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "268.38 285.43 240.38 285.43 240.38 247.93 260.04 247.93 268.38 255.57 268.38 285.43",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.04 247.93 257.99 256.9 268.38 255.57 260.04 247.93",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.04 247.93 260.04 255.57 268.38 255.57 260.04 247.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 261.08,
    x2: 261.69,
    y2: 261.08,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 264.99,
    x2: 261.69,
    y2: 264.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 268.9,
    x2: 261.69,
    y2: 268.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 272.82,
    x2: 261.69,
    y2: 272.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 276.73,
    x2: 261.69,
    y2: 276.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.41 286.7 373.41 286.7 373.41 249.19 393.07 249.19 401.41 256.83 401.41 286.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "403.04 285.43 375.04 285.43 375.04 247.93 394.7 247.93 403.04 255.57 403.04 285.43",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.7 247.93 392.66 256.9 403.04 255.57 394.7 247.93",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.7 247.93 394.7 255.57 403.04 255.57 394.7 247.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 261.08,
    x2: 396.36,
    y2: 261.08,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 264.99,
    x2: 396.36,
    y2: 264.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 268.9,
    x2: 396.36,
    y2: 268.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 272.82,
    x2: 396.36,
    y2: 272.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 276.73,
    x2: 396.36,
    y2: 276.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.73 286.7 101.73 286.7 101.73 249.19 121.39 249.19 129.73 256.83 129.73 286.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "131.37 285.43 103.37 285.43 103.37 247.93 123.03 247.93 131.37 255.57 131.37 285.43",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 247.93 120.98 256.9 131.37 255.57 123.03 247.93",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 247.93 123.03 255.57 131.37 255.57 123.03 247.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 261.08,
    x2: 124.69,
    y2: 261.08,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 264.99,
    x2: 124.69,
    y2: 264.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 268.9,
    x2: 124.69,
    y2: 268.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 272.82,
    x2: 124.69,
    y2: 272.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 276.73,
    x2: 124.69,
    y2: 276.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.74 380.42 238.74 380.42 238.74 342.91 258.4 342.91 266.74 350.55 266.74 380.42"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "268.38 379.15 240.38 379.15 240.38 341.65 260.04 341.65 268.38 349.29 268.38 379.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.04 341.65 257.99 350.62 268.38 349.29 260.04 341.65",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.04 341.65 260.04 349.29 268.38 349.29 260.04 341.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 354.8,
    x2: 261.69,
    y2: 354.8,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 358.71,
    x2: 261.69,
    y2: 358.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 362.63,
    x2: 261.69,
    y2: 362.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 366.54,
    x2: 261.69,
    y2: 366.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 370.45,
    x2: 261.69,
    y2: 370.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.41 380.42 373.41 380.42 373.41 342.91 393.07 342.91 401.41 350.55 401.41 380.42"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "403.04 379.15 375.04 379.15 375.04 341.65 394.7 341.65 403.04 349.29 403.04 379.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.7 341.65 392.66 350.62 403.04 349.29 394.7 341.65",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.7 341.65 394.7 349.29 403.04 349.29 394.7 341.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 354.8,
    x2: 396.36,
    y2: 354.8,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 358.71,
    x2: 396.36,
    y2: 358.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 362.63,
    x2: 396.36,
    y2: 362.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 366.54,
    x2: 396.36,
    y2: 366.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 370.45,
    x2: 396.36,
    y2: 370.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.73 380.42 101.73 380.42 101.73 342.91 121.39 342.91 129.73 350.55 129.73 380.42"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "131.37 379.15 103.37 379.15 103.37 341.65 123.03 341.65 131.37 349.29 131.37 379.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 341.65 120.98 350.62 131.37 349.29 123.03 341.65",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 341.65 123.03 349.29 131.37 349.29 123.03 341.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 354.8,
    x2: 124.69,
    y2: 354.8,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 358.71,
    x2: 124.69,
    y2: 358.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 362.63,
    x2: 124.69,
    y2: 362.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 366.54,
    x2: 124.69,
    y2: 366.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 370.45,
    x2: 124.69,
    y2: 370.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.06 331.75 169.06 331.75 169.06 294.25 188.73 294.25 197.06 301.89 197.06 331.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "198.7 330.49 170.7 330.49 170.7 292.98 190.36 292.98 198.7 300.62 198.7 330.49",
    style: {
      fill: "#F77474",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.36 292.98 188.32 301.95 198.7 300.62 190.36 292.98",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.36 292.98 190.36 300.62 198.7 300.62 190.36 292.98",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.06,
    y1: 306.14,
    x2: 192.02,
    y2: 306.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.06,
    y1: 310.05,
    x2: 192.02,
    y2: 310.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.06,
    y1: 313.96,
    x2: 192.02,
    y2: 313.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.06,
    y1: 317.87,
    x2: 192.02,
    y2: 317.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.06,
    y1: 321.78,
    x2: 192.02,
    y2: 321.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.74 192.98 238.74 192.98 238.74 155.47 258.4 155.47 266.74 163.11 266.74 192.98"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "268.38 191.71 240.38 191.71 240.38 154.21 260.04 154.21 268.38 161.85 268.38 191.71",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.04 154.21 257.99 163.18 268.38 161.85 260.04 154.21",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.04 154.21 260.04 161.85 268.38 161.85 260.04 154.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 167.36,
    x2: 261.69,
    y2: 167.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 171.27,
    x2: 261.69,
    y2: 171.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 175.18,
    x2: 261.69,
    y2: 175.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 179.09,
    x2: 261.69,
    y2: 179.09,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.73,
    y1: 183.01,
    x2: 261.69,
    y2: 183.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.07 144.31 306.07 144.31 306.07 106.81 325.74 106.81 334.07 114.44 334.07 144.31"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "335.71 143.05 307.71 143.05 307.71 105.54 327.37 105.54 335.71 113.18 335.71 143.05",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.37 105.54 325.33 114.51 335.71 113.18 327.37 105.54",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.37 105.54 327.37 113.18 335.71 113.18 327.37 105.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.07,
    y1: 118.69,
    x2: 329.03,
    y2: 118.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.07,
    y1: 122.61,
    x2: 329.03,
    y2: 122.61,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.07,
    y1: 126.52,
    x2: 329.03,
    y2: 126.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.07,
    y1: 130.43,
    x2: 329.03,
    y2: 130.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.07,
    y1: 134.34,
    x2: 329.03,
    y2: 134.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "401.41 192.98 373.41 192.98 373.41 155.47 393.07 155.47 401.41 163.11 401.41 192.98"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "403.04 191.71 375.04 191.71 375.04 154.21 394.7 154.21 403.04 161.85 403.04 191.71",
    style: {
      fill: "#F77474",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.7 154.21 392.66 163.18 403.04 161.85 394.7 154.21",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.7 154.21 394.7 161.85 403.04 161.85 394.7 154.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 167.36,
    x2: 396.36,
    y2: 167.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 171.27,
    x2: 396.36,
    y2: 171.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 175.18,
    x2: 396.36,
    y2: 175.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 179.09,
    x2: 396.36,
    y2: 179.09,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.4,
    y1: 183.01,
    x2: 396.36,
    y2: 183.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.73 192.98 101.73 192.98 101.73 155.47 121.39 155.47 129.73 163.11 129.73 192.98"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "131.37 191.71 103.37 191.71 103.37 154.21 123.03 154.21 131.37 161.85 131.37 191.71",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 154.21 120.98 163.18 131.37 161.85 123.03 154.21",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.03 154.21 123.03 161.85 131.37 161.85 123.03 154.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 167.36,
    x2: 124.69,
    y2: 167.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 171.27,
    x2: 124.69,
    y2: 171.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 175.18,
    x2: 124.69,
    y2: 175.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 179.09,
    x2: 124.69,
    y2: 179.09,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.73,
    y1: 183.01,
    x2: 124.69,
    y2: 183.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-61"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.64,
    cy: 369.59,
    rx: 49.74,
    ry: 9.56,
    style: {
      fill: "#F77474"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.64,
    cy: 369.59,
    rx: 49.74,
    ry: 9.56,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.91,238.51a.71.71,0,0,1-.22.15.85.85,0,0,1-1.13-.41l-2-4.21a.86.86,0,0,1,1.55-.73l2,4.21A.85.85,0,0,1,282.91,238.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,248.9a11.66,11.66,0,0,1,5.84,2.54c2.8,2.29,8.9,5.34,16.79,7.12s9.91,2,9.91,2l-2-10.93s-11.19.25-16-.51-10.43-5.08-13-7.37S284.71,248.9,284.71,248.9Z",
    style: {
      fill: "#F77474",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.22,249.38a1.51,1.51,0,0,1-.32.22,1.29,1.29,0,0,1-1.71-.61l-5-10.55a1.28,1.28,0,1,1,2.32-1.1l5,10.55A1.3,1.3,0,0,1,288.22,249.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.56,231.49a13.35,13.35,0,1,1,.68-18.87A13.37,13.37,0,0,1,284.56,231.49Zm-16.44-17.68a10.79,10.79,0,1,0,15.24.55A10.8,10.8,0,0,0,268.12,213.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.46,238.74s1.39-.74,2,.4,2.12,3.51,1.83,4.37-1.91,1-2.7.11a16.6,16.6,0,0,1-1.88-3.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.12,240.44l5.34-1.7a1.54,1.54,0,0,1,.7,1.12c.11.8,2.36,5.25,2.11,6.37s-5.13,3.17-5.62,2.56-3.37-7.56-3.37-7.56S280.2,240.7,281.12,240.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.27,
    y1: 240.66,
    x2: 282.45,
    y2: 242.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.97,
    y1: 242.74,
    x2: 283.58,
    y2: 244.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.78,
    y1: 244.67,
    x2: 284.62,
    y2: 247.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,219.66s-4.33,8.13-4.83,16.27,6.86,9.15,7.88,9.91,4.83,32.8,4.83,32.8-26.7,34.33-26.7,38.14S286,358,286,358l5.59.26S300,334.58,302,329s2.79-14.24,2.79-14.24l24.67-23.14s2.79,22.63,5.34,27.46,20.08,39.67,20.08,39.67a27,27,0,0,0,4.58.76,7.94,7.94,0,0,0,3.05-.76l-15-43s.76-39.16-2.54-45.52-11.7-15.51-11.7-15.51-7.12-29.49-8.14-34.07-6.86-8.39-9.66-8.39S308.61,219.66,308.61,219.66Z",
    style: {
      fill: "#F77474",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,214.57l3.56,5.59s-2,8.65-.25,6.62,4.57-9.41,6.1-10.94a8.59,8.59,0,0,0,2-3.56L307.84,208Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.21,195.92s-.45,4.67,1.07,7,2,3.05,1.53,4.57-2.8,1.53-2.29,2.8,3.31,1.78,3.31,1.78,3.05,7.12,5.84,7.12,9.94-7,10.95-9.55-9.42-9.27-11.2-10.79S290.24,193.12,288.21,195.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.43,204.78c.28.85.19,1.65-.21,1.78s-1-.45-1.23-1.3-.2-1.65.2-1.79S294.14,203.92,294.43,204.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,212.72s2.46,0,3.28-3.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.47,184.06h-5.26c-3.38,0-3.75,6.75,3.38,14.26s21.39,16.51,29.65,16.51,15.39,2.25,18.39,10.51,7.88,15.76,22.52,12.76,18.39-22.89,7.88-39.78-24.4-13.89-31.53-10.51-19.14,4.5-21.39,0-7.57-7.53-13.2-7.53S289.47,184.06,289.47,184.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,358.74l-15-43s.76-39.16-2.54-45.52c-2.84-5.45-9.4-12.94-11.21-15L314.25,261c1.16,8.6,2.24,17.65,2.24,17.65s-26.7,34.33-26.7,38.14S286,358,286,358l5.59.26S300,334.58,302,329s2.79-14.24,2.79-14.24l24.67-23.14s2.79,22.63,5.34,27.46,20.08,39.67,20.08,39.67a27,27,0,0,0,4.58.76A7.94,7.94,0,0,0,362.51,358.74Z",
    style: {
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.29,219.91a4.75,4.75,0,0,0-5.6,3.05c-1.52,4.07,4.83,7.63,9.66,13s18.82,16.27,18.82,16.27l8.14,25.94,3.81-.77S349,247.88,349,247.12s-21.35-21.87-22.12-22.63-3.81-4.07-3.81-4.07",
    style: {
      fill: "#F77474",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.31,278.14l-1.53,6.61,2.54,4.83s2,.76,2.55-.26l.5-1s2.55-.26,2.8-2.55-3.05-8.39-3.05-8.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,358s-12.46,9.16-13,10.68,16.78-2.54,18.31-2.8.25-7.62.25-7.62Z",
    style: {
      fill: "#F77474",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.28,367.21a5.53,5.53,0,0,0-1.27,1.44c-.51,1.53,16.78-2.54,18.31-2.8.52-.08.71-1,.74-2.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.88,358.74s-10.42,1.78-9.15,3.3a10.82,10.82,0,0,0,7.12,3c2.54,0,3.56.76,5.85,2s3.81,1.27,4.57-.77-.76-7.62-.76-7.62S356.41,360,354.88,358.74Z",
    style: {
      fill: "#F77474",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.7,367.13c2.28,1.27,3.81,1.27,4.57-.77a2.84,2.84,0,0,0,.16-.72c-3.79,1.91-7.28-2.63-10.46-2.63-2,0-4.79-1.11-6.64-2-.6.34-.88.68-.6,1a10.82,10.82,0,0,0,7.12,3C355.39,365.09,356.41,365.85,358.7,367.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.59,196.44c2,4,4.89,8.77,8.23,10.72",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,189.75s.45,1.31,1.27,3.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.31,204.68a12.4,12.4,0,0,1,2.34,2.48",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.23,188.52s3.52,12,15.3,17.58S319.06,210.5,334,204c11.44-5,22.68-4.7,29.61-1.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.43,228.25c-.19-3.87,3.77-3.31,4.23-3.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.57,207.51s6.86-1.23,20.22-1.06,21.63,13.9,19,22.16c-2.42,7.58-14.9,7.62-18.3,3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormNotFound);
export default __webpack_public_path__ + "static/media/formNotFound.fbda4194bf3a3ef6b7fa71dc379fd924.svg";
export { ForwardRef as ReactComponent };